import { Typography } from "@mui/material";

function MissingTableValue({
  message = " Missing field",
}: {
  message?: string;
}) {
  return (
    <Typography sx={{ color: "error.main", fontWeight: 300 }}>
      {message}
    </Typography>
  );
}

export default MissingTableValue;
